<template>
    <div class="partials">
        <loader-block v-if="loading" :green-color="true" />
        <transition-group name="fade">
            <template v-if="!loading">
                <p
                    v-for="(part, i) in paymentParts"
                    :key="`${part.payment_at}-${i}`"
                    class="partials__part ml-30"
                    :class="{ partials__part_current: i === 0 }"
                >
                    {{ t(i === 0 ? "payments.pay_now" : "payments.payment") }}
                    <span v-if="i !== 0" class="mr-3">{{ formatDateDdMmYYYY(part.payment_at) }}</span>
                    <span class="price">{{ part.price_info.price.amount_formatted }}</span>
                </p>
            </template>
        </transition-group>
    </div>
</template>

<script>
import LoaderBlock from "@components/Loaders/LoaderBlock"
import formatDate from "@mixins/formatDate"

export default {
    name: "PublicOfferPartialSchedule",
    components: {
        LoaderBlock
    },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        paymentParts: {
            type: Array,
            required: true
        }
    },
    mixins: [formatDate]
}
</script>

<style lang="sass" scoped>
@import 'resources/sass/vars'

.partials
    &__part
        width: fit-content
        padding: 5px 15px
        font-weight: 400
        font-size: 13px
        line-height: 130%
        border-radius: 4px
        color: $text-accent-color
        border: 1px solid transparent
        &:not(:last-child)
            margin-bottom: 5px
        &_current
            background: $bgc-alert
            border-color: $border-color4
    .price
        font-weight: 700
        color: $text-color
</style>
